import { notifications } from '@mantine/notifications';
import { Logger } from 'src/utils/Logger';
import { ApiError, ApiErrorCode } from 'src/error/ApiError';

export const notifyAndLogError = (
  title: string,
  message: string,
  error: unknown,
  additionalInfo: Record<string, unknown> = {},
) => {
  const isIntegrityError =
    error instanceof ApiError && error.code === ApiErrorCode.ENTITY_HAS_DEPENDENCIES;

  if (!isIntegrityError) {
    notifications.show({ title, message, color: 'red' });
    Logger.error(`${title}: ${message}`, error, additionalInfo);
    return;
  }

  Logger.warn(`${title}: ${message}`, additionalInfo);
};

export const notifyAndWarn = (
  title: string,
  message: string,
  additionalInfo: Record<string, unknown> = {},
) => {
  notifications.show({ title, message, color: 'amber' });
  Logger.warn(`${title}: ${message}`, additionalInfo);
};
